<template>
  <section class="blog-text-box-new">
    <a :href="shopifyData.secLink ? shopifyData.secLink : '#'" :style="customizeContent">
      <div class="blog_content">
        <div class="new-blog-text blog_text">
          <span v-html="shopifyData.blogText" />
        </div>
      </div>
    </a>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    customizeContent() {
      return {
        'padding-top':
          window.innerWidth > 768
            ? `${this.shopifyData.deskPaddingTop}px`
            : `${this.shopifyData.mobPaddingTop}px`,
        'padding-bottom':
          window.innerWidth > 768
            ? `${this.shopifyData.deskPaddingBottom}px`
            : `${this.shopifyData.mobPaddingBottom}px`,
        background: `${this.shopifyData.bgColor}`,
      };
    },
  },
};
</script>

<style scoped>
.blog-text-box-new a {
  display: block;
}

.blog_content {
  max-width: 816px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
}
</style>
<style>
.new-blog-text,
.new-blog-text * {
  color: #000;
  font-family: adobe-caslon-pro, sans-serif !important;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 142.5%;
  letter-spacing: 0.36px;
}
</style>
